import { createConfigCrud } from "features/shared/lib/technical-config-tab/api/crudCallers";
import { customApiCall } from "utils/axios";

import type {
  CommonProps,
  RoomConfigCreatePayload,
  RoomConfigSavePayload,
  RoomTypeCatalogItem,
  RoomTypeGroupDetail,
  SaveRoomConfigProps,
} from "../model/types";

import roomConfigTabUrls from "./urls";

const roomConfigCrud = createConfigCrud<RoomConfigCreatePayload | RoomConfigSavePayload>(roomConfigTabUrls.groupDetail);

export const saveRoomConfig = ({ data, hasConfig, projectId, roomFunctionValue, scenario }: SaveRoomConfigProps) =>
  roomConfigCrud.save({ data, isExisting: hasConfig, projectId, recordId: roomFunctionValue, scenario });

export const deleteRoomConfig = ({ projectId, roomFunctionValue, scenario }: CommonProps) =>
  roomConfigCrud.remove({ projectId, recordId: roomFunctionValue, scenario });

export const createCatalogItem = ({ data }: { data: Omit<RoomTypeCatalogItem, "id" | "projectId"> }) =>
  customApiCall.post({ data, url: roomConfigTabUrls.createCatalogItem() });

export const fetchRoomTypeDetail = ({ projectId, roomFunctionValue, scenario }: CommonProps) =>
  customApiCall.get({
    url: roomConfigTabUrls.groupDetail(projectId, roomFunctionValue, scenario),
  }) as Promise<RoomTypeGroupDetail>;

export const fetchRoomSchedulePreset = (kind: string) =>
  customApiCall.get({ url: roomConfigTabUrls.schedulePreset(kind) });
